import { render, staticRenderFns } from "./addAwards-dialog.vue?vue&type=template&id=8e53f1ca&scoped=true"
import script from "./addAwards-dialog.vue?vue&type=script&lang=js"
export * from "./addAwards-dialog.vue?vue&type=script&lang=js"
import style0 from "./addAwards-dialog.vue?vue&type=style&index=0&id=8e53f1ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e53f1ca",
  null
  
)

export default component.exports